import request from '@/utils/request'
// 巡检列表
export function inspectionList(data) {
    return request({
        url:'/netbar/api/inspection_work/v1/list',
        method:'post',
        data
    })
}
// 巡检列表详情
export function inspectionDetails(data) {
    return request({
        url:'/netbar/api/inspection_work/v1/detail',
        method:'post',
        data
    })
}
// 搜索网吧列表
export function SearchList(data) {
    return request({
        url:'/netbar/api/inspection_work/v1/internet_bar_list',
        method:'post',
        data
    })
}
// 保存巡检列表
export function inspectionSave(data) {
    return request({
        url:'/netbar/api/inspection_work/v1/insert',
        method:'post',
        data
    })
}